import React, { useEffect, useState } from "react"
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography, FormControl, FormHelperText } from "@mui/material"
import Grid from "@mui/material/Grid2"
import DownloadIcon from "@mui/icons-material/Download"
import CustomTable from "../../components/table/Table"
import { useDispatch, useSelector } from "react-redux";
import { createRole, deleteRole, fetchRoles, updateRole } from "../../redux/Slice/roleSlice"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { side_menus } from "../../constants/SideMenus";
import { toast } from "sonner"
import { clearMessage } from "../../redux/Slice/message";

const columns = [
  { id: 'sno', label: 'S.No', minWidth: 150, align:'start' },
  { id: 'name', label: 'Role Name', minWidth: 150, align:'start' },
  { id: 'modules', label: 'Modules', minWidth: 150, align:'start' },
  { id: 'status', label: 'Status', minWidth: 150, align:'start' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, delete: true}] },
];

const EmployeeRoleSetup = () => { 

  const dispatch = useDispatch();

  
  const { profile } = useSelector((state) => state.auth);
  // console.log("profile",profile);
  
  
  const getModule = profile?.permissions?.find(va => va.moduleName === "Employee Management" || va.moduleName === "*")?.actions;
    

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");

  const [buttonVal, setButtonVal] = useState("Submit");

  const initialState = {
    "name": "",
    "status": true,
    "permissions": [] 
  }

  const [formData, setFormdata] = useState(initialState);

  const [error, setError] = useState(initialState);

  console.log(error);

  const { roles, totalCount } = useSelector((state)=> state.roles);

  const modifiedRows = roles ? roles?.map((va, index)=> ({sno:(index+1+((page-1)*rowsPerPage)), ...va, modules:(va.permissions.map(ab => `${ab.moduleName} - ${(ab.actions).join(', ')}`)).join(' & ')})) : [] ;

  const message = useSelector((state) => state.message)

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  }

  const handleExport = () => {
    console.log("Exporting data...")
  }

  const handleChange = (key, value) => {
      setFormdata({...formData, [key]: value})
  }

  const handleModuleChange = (module, action) => {
    if(Array.isArray(action) ){
      console.log(module);
    setFormdata({...formData, permissions: ((formData.permissions).map(va => va.moduleName)).includes(module) ? (formData.permissions).filter(mod => mod.moduleName !==  module) : [...formData.permissions, {moduleName: module, actions: action ? action?.map(bc => bc.value) : ["*"]}]})
    }
    else{
      setFormdata((prevFormData) => {
        const permissions = prevFormData.permissions;
        const existingModule = permissions.find((mod) => mod.moduleName === module);
      
        if (!existingModule) {
          // If the module does not exist, add it with actions
          console.log("1", module);
          return {
            ...prevFormData,
            permissions: [
              ...permissions,
              { moduleName: module, actions: action ? [action] : ["*"] },
            ],
          };
        }
      
        const existingActions = existingModule.actions;
      
        if (!existingActions.includes(action) && action) {
          // If the module exists but the action is not present
          console.log("2", module, existingActions.includes(action));
          return {
            ...prevFormData,
            permissions: permissions.map((mod) =>
              mod.moduleName === module
                ? {
                    ...mod,
                    actions: [
                      ...existingActions.filter((act) => act !== "*"), // Remove "*" if present
                      action,
                    ],
                  }
                : mod
            ),
          };
        }
      
        if (existingActions.includes(action) && existingActions.length > 1) {
          // If the action is present and there are multiple actions, remove the specific action
          console.log("3", module);
          return {
            ...prevFormData,
            permissions: permissions.map((mod) =>
              mod.moduleName === module
                ? {
                    ...mod,
                    actions: existingActions.filter((act) => act !== action),
                  }
                : mod
            ),
          };
        }
      
        // If only one action is left (including "*"), remove the entire module
        return {
          ...prevFormData,
          permissions: permissions.filter((mod) => mod.moduleName !== module),
        };
      });
      
    }
  }

  console.log(formData);

  const handleSelectAll = (event) => {
    const modules = side_menus.map(va => ({moduleName: va.menuName, actions: va?.actions ? va?.actions?.map(ab => ab.value) : ["*"]}));
    if(event.target.checked){
    setFormdata({...formData, permissions: modules})
    }
    else{
      setFormdata({...formData, permissions: []})
    }
  }

  const handleReset = () => {
    setFormdata(initialState);
    setError(initialState);
    setButtonVal("Submit");
  }

  const handleEdit = (val) =>{
    setFormdata(val);
    setButtonVal("Update");
  }

  const handleStatusChange = (row) => {
    dispatch(setLoading(true));
    const r_id = row._id;
    const formData = {
      status : !row.status
    }
    dispatch(updateRole({r_id, formData}))
    .then(()=>{
      dispatch(setLoading(false));
      handleReset();
      //Refresh RolesList
      refreshRolesList();
    })
    .catch((error)=>{
      dispatch(setLoading(false));
    })
  }
  

  const handleDelete = (val) => {
    dispatch(setLoading(true))
    dispatch(deleteRole(val))
    .then(()=>{
      dispatch(setLoading(false));
      //Refresh RolesList
      refreshRolesList();
    })
    .catch((error)=>{
      dispatch(setLoading(false));
    })
  }

  const handleSubmit = () => {
    if((formData?.permissions).length === 0 && formData?.name === ""){
      setError({name:"Name Field Is Required", permissions:"Check atleast one permission"})
    }
    else if((formData?.permissions).length === 0){
      setError({permissions:"Check atleast one permission"})
    }
    else if (formData?.name === ""){
      setError({name:"Name Field Is Required"})
    }
    else{
      dispatch(setLoading(true))
      if(buttonVal === "Submit"){
      dispatch(createRole(formData))
      .then(()=>{
        dispatch(setLoading(false));
        handleReset();
        //Refresh RolesList
        refreshRolesList();
      })
      .catch((error)=>{
        dispatch(setLoading(false));
      })
    }
    else{
      const r_id = formData._id;
      console.log(r_id);
      dispatch(updateRole({r_id, formData}))
      .then(()=>{
        dispatch(setLoading(false));
        handleReset();
        //Refresh RolesList
        refreshRolesList();
      })
      .catch((error)=>{
        dispatch(setLoading(false));
      })
    }
    }
  }

  // Add a new function to refresh the roles list
const refreshRolesList = () => {
  const params = {
    page: page,
    limit: rowsPerPage,
    searchTerm: searchTerm
  }
  
  if (getModule?.includes("role_get") || getModule?.includes("*")) {
    dispatch(fetchRoles(params));
  }
}

  useEffect(()=>{
    const params = {
      page: page,
      limit: rowsPerPage,
      searchTerm: searchTerm
    }
    if(getModule?.includes("role_get") || getModule?.includes("*")){
    // dispatch(setLoading(true))
    dispatch(fetchRoles(params))
    // .then(() => {
    //     dispatch(setLoading(false))
    //         })
    // .catch((error) => {
    //     dispatch(setLoading(false))
    //   })
    }
  }, [dispatch, getModule, page, rowsPerPage, searchTerm])

  return (
    <div className="content">
      {(getModule?.includes("role_create") || getModule?.includes("*")) &&
      <Box sx={{ p: 4, border: "1px solid #ddd", borderRadius: 2 }} fullWidth>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Employee Role Setup
        </Typography>
        <FormControl sx={{ mb: 3, width: "50%" }}>
  <TextField
    id="role"
    name="role"
    variant="outlined"
    value={formData?.name}
    onChange={(e) => handleChange("name", e.target.value)}
    placeholder="Role Name"
    error ={error.name !== "" ? true : false}
    helperText={error?.name}
  />
</FormControl>
                <FormControl
        required
        error ={error.permissions !== "" ? true : false}
        >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Module Permission:
          <FormControlLabel 
          control={<Checkbox checked={(formData.permissions).length === side_menus.length} onChange={handleSelectAll} />} label="Select All" sx={{ ml: 2 }} 
          />
          {error?.permissions !== "" && <FormHelperText>{error?.permissions}</FormHelperText>}
        </Typography>
        <Grid container spacing={2}>
          {side_menus.map((module, index) => (
            <Grid item size={12} key={index}>
                <Grid container spacing={2}>
                <Grid item size={2} >
                <FormControlLabel control={<Checkbox checked={((formData.permissions).map(va => va.moduleName)).includes(module.menuName) || false} onChange={() => handleModuleChange(module.menuName, module?.actions)} />} label={<Typography sx={{fontWeight: 600}}>{module.menuName}</Typography>} />
                </Grid>
                <Grid item size={10}>
                <Grid container spacing={2}>
                {module?.actions?.map ((action, index)=>(
                  <Grid item size={2} key={index} >
                <FormControlLabel control={<Checkbox checked={formData.permissions
    ?.find(ca => ca.moduleName === module.menuName)?.actions?.includes(action.value) || false} onChange={() => handleModuleChange(module.menuName, action.value)} />} label={action.name} />
                </Grid>
                ))}
                </Grid>
                </Grid>
                </Grid>
            </Grid>
          ))}
        </Grid>
        </FormControl>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "end" }} gap={2}>
          <Button variant="outlined" color="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            {buttonVal}
          </Button>
        </Box>
      </Box>
          }
      {(getModule?.includes("role_get") || getModule?.includes("*")) &&
      <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Employee Roles Table <Typography component="span">({totalCount})</Typography>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField size="small" placeholder="Search by Role Name" value={searchTerm} onChange={handleSearch} fullWidth />
          {/* <Button variant="contained" onClick={handleSearch}>
            search
          </Button> */}
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleExport} sx={{ ml: 2, px: 3 }}>
            Export
          </Button>
        </Box>
      </Box>

      <CustomTable columns={columns} rows={ roles ? modifiedRows : [] } page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} handleEdit={handleEdit} handleDelete={handleDelete} handleStatusChange={handleStatusChange} totalCount={totalCount}/>
      </>
      }
    </div>
  )
}

export default EmployeeRoleSetup
